var map = {
	"./2playsamonth/BannerLogo.png": 2375,
	"./2playsamonth/HeroCoders.png": 52343,
	"./ActivityBanner": 23815,
	"./ActivityBanner.jsx": 23815,
	"./activitiesConfig": 93729,
	"./activitiesConfig.js": 93729,
	"./activityBanner.css": 83872,
	"./banner.png": 9745,
	"./hackathon/Logo.png": 11218,
	"./hackathon/Logo.svg": 85798,
	"./hackathon/img-hero-coders.png": 86662,
	"common/activities/2playsamonth/BannerLogo.png": 2375,
	"common/activities/2playsamonth/HeroCoders.png": 52343,
	"common/activities/ActivityBanner": 23815,
	"common/activities/ActivityBanner.jsx": 23815,
	"common/activities/activitiesConfig": 93729,
	"common/activities/activitiesConfig.js": 93729,
	"common/activities/activityBanner.css": 83872,
	"common/activities/banner.png": 9745,
	"common/activities/hackathon/Logo.png": 11218,
	"common/activities/hackathon/Logo.svg": 85798,
	"common/activities/hackathon/img-hero-coders.png": 86662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6927;